import type { AccessToken } from '@okta/okta-auth-js';
import type { RequestMiddleware } from 'graphql-request';

import { authClient } from '@sportybot-web/auth/client';

export const requestMiddleware: RequestMiddleware = async (request) => {
  const token = (await authClient.tokenManager.get('accessToken')) as AccessToken;
  return {
    ...request,
    headers: {
      ...(request.headers as Record<string, string>),
      authorization: `Bearer ${token.accessToken}`,
    },
  };
};
